// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608141026/js/" + chunkId + "." + {"44":"cd14169a","225":"77dcac1f","481":"6cf12fae","486":"1b68766b","770":"3390b0e1"}[chunkId] + ".0.9247372140294771.chunk.js";
};